import { serverResponse } from 'app'

import * as actions from '../../actions/reset'

export default (state = actions.getResetInitialState(), action = {}) => {
  switch (action.type) {
    case actions.RESET_FETCH: {
      return serverResponse(state, { loading: true })
    }
    case actions.RESET_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.RESET_FETCH_ERROR: {
      return serverResponse({ error: action.payload })
    }
    case actions.RESET_FETCH_FULFILLED: {
      return serverResponse(action.payload, {
        loaded: true,
      })
    }

    default:
  }
  return state
}
